"use client";

import React from "react";
import { Box, Container, Typography, Link } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useColorScheme } from "@mui/material/styles";
import Image from "next/image";
import Logo from "@/src/common/components/Logo";

const FooterSection = styled(Box)<{ isDarkMode: boolean }>(
  ({ theme, isDarkMode }) => ({
    backgroundColor: isDarkMode ? "#0d1117" : "#313132",
    color: "white",
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(4),
  })
);

const Footer: React.FC = () => {
  const { mode, systemMode } = useColorScheme();
  const isDarkMode =
    mode === "dark" || (mode === "system" && systemMode === "dark");

  return (
    <FooterSection isDarkMode={isDarkMode}>
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: "center",
            gap: 4,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Logo width={180} height={42} darkMode />
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              gap: { xs: 2, md: 4 },
              alignItems: "center",
            }}
          >
            <Link
              href="contactUs"
              sx={{
                color: "rgba(255, 255, 255, 0.8)",
                textDecoration: "none",
                fontSize: "0.9rem",
                "&:hover": {
                  color: isDarkMode ? "#F49045" : "#42A6F6",
                  textDecoration: "underline",
                },
              }}
            >
              Subscribe to our newsletter
            </Link>

            <Link
              href="mailto:info@bouncepoint.io"
              sx={{
                color: "rgba(255, 255, 255, 0.8)",
                textDecoration: "none",
                fontSize: "0.9rem",
                "&:hover": {
                  color: isDarkMode ? "#F49045" : "#42A6F6",
                  textDecoration: "underline",
                },
              }}
            >
              Email us
            </Link>

            <Link
              href="/privacyPolicy"
              sx={{
                color: "rgba(255, 255, 255, 0.8)",
                textDecoration: "none",
                fontSize: "0.9rem",
                "&:hover": {
                  color: isDarkMode ? "#F49045" : "#42A6F6",
                  textDecoration: "underline",
                },
              }}
            >
              Privacy policy
            </Link>
          </Box>

          <Typography
            variant="body2"
            sx={{
              color: "rgba(255, 255, 255, 0.7)",
              textAlign: { xs: "center", md: "right" },
              fontSize: "0.8rem",
            }}
          >
            © 2025 Bouncepoint, Inc. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </FooterSection>
  );
};

export default Footer;
